import React from 'react';
import { cn } from '../../utils/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <div className={cn(
      "bg-white rounded-xl shadow-lg p-8 backdrop-blur-sm bg-opacity-90 border border-gray-100",
      className
    )}>
      {children}
    </div>
  );
}